import { Data } from 'signup-constants/signupData/Data';
import { getCompanySizeOptionFromEmployeesRange } from '../company-info/companySize';
import { getSentryExtra } from '../error/getSentryExtra';
import { LOG } from '../http-complete-verification/handleCompleteVerificationError';
import { EndpointKey } from '../http/EndpointKey';
import { setEndpointTimeCompleted } from '../store/http-responses/action-creators';
import { getEndpointRetries } from '../store/http-responses/selectors';
import { bulkSetSignupDataAndSetValid, bulkUpdateGtkmData, setSignupDataValue } from '../store/signup-data/action-creators';
import { Tracker } from '../store/tracking/action-creators';
import { isPurchaseProductisedFlow } from '../utils/gtkm/isPurchaseProductisedFlow';
import { getGTKMDomainToUse, getGTKMFallbackDomain } from './gtkmDomainUtils';
import { updateStepOrdersAfterAuth, updateStepOrdersInDomainStep } from './updateStepOrders';
import { updateStepOrdersAfterAuthPurchase, updateStepOrdersInDomainStepPurchase } from './updateStepOrderPurchase';
export const handleACQ177GTKMCompanyInfoSuccess = ({
  domain,
  name,
  industry,
  companySizeLowerBracket,
  companySizeUpperBracket,
  isFreeEmailDomain
}, dispatch, getState) => {
  const state = getState();
  dispatch(Tracker.signupInteraction('gtkm-company-info-prefill-success'));
  dispatch(Tracker.signupInteraction('gtkm-company-info-is-freemail', {
    currentValue: isFreeEmailDomain
  }));
  const companySizeValue = companySizeLowerBracket && companySizeUpperBracket ? getCompanySizeOptionFromEmployeesRange({
    min: companySizeLowerBracket,
    max: companySizeUpperBracket
  }) : '';
  const isPurchase = isPurchaseProductisedFlow();
  const gtkmDataWithoutDomain = isPurchase ? {
    [Data.CompanySize]: companySizeValue,
    [Data.CompanyName]: name || ''
  } : {
    [Data.CompanySize]: companySizeValue,
    [Data.CompanyName]: name || '',
    [Data.Industry]: industry || ''
  };
  const gtkmData = Object.assign({}, gtkmDataWithoutDomain, {
    [Data.CompanyDomain]: domain || ''
  });
  dispatch(bulkUpdateGtkmData(gtkmData));
  dispatch(bulkSetSignupDataAndSetValid(gtkmDataWithoutDomain));
  const retries = getEndpointRetries(state, EndpointKey.GTKMCompanyInfoACQ177);
  if (!isFreeEmailDomain && retries < 1) {
    dispatch(setSignupDataValue(Data.CompanyDomain, domain || ''));
  }
  dispatch(setEndpointTimeCompleted(EndpointKey.GTKMCompanyInfoACQ177, new Date()));
  if (retries < 1) {
    if (isPurchase) {
      updateStepOrdersAfterAuthPurchase({
        gtkmData,
        dispatch,
        state,
        isFreeEmailDomain
      });
    } else {
      updateStepOrdersAfterAuth({
        gtkmData,
        dispatch,
        state,
        isFreeEmailDomain
      });
    }
  } else {
    if (isPurchase) {
      updateStepOrdersInDomainStepPurchase({
        gtkmData,
        dispatch,
        state
      });
    } else {
      updateStepOrdersInDomainStep({
        gtkmData,
        dispatch,
        state
      });
    }
  }
};
export const handleACQ177GTKMCompanyInfoError = (error, dispatch, getState) => {
  const state = getState();
  dispatch(Tracker.signupInteraction(`gtkm-industry-prefill-${error.status}`));
  dispatch(Tracker.signupInteraction(`gtkm-company-info-prefill-error-${error.status}`));
  const gtkmDomain = getGTKMDomainToUse(state);
  dispatch(bulkUpdateGtkmData({
    [Data.CompanyDomain]: gtkmDomain
  }));
  const retries = getEndpointRetries(state, EndpointKey.GTKMCompanyInfoACQ177);
  LOG.error('GTKM Company Information Request Failed', {
    extra: Object.assign({}, getSentryExtra(error), {
      gtkmDomain
    })
  });
  if (retries < 1) {
    const fallbackDomain = getGTKMFallbackDomain(state);
    dispatch(setSignupDataValue(Data.CompanyDomain, fallbackDomain));
  }
  const gtkmData = {
    [Data.CompanyDomain]: gtkmDomain
  };
  const isPurchase = isPurchaseProductisedFlow();
  if (retries < 1) {
    if (isPurchase) {
      updateStepOrdersAfterAuthPurchase({
        gtkmData,
        dispatch,
        state,
        isGTKMEndpointFailed: true
      });
    } else {
      updateStepOrdersAfterAuth({
        gtkmData,
        dispatch,
        state,
        isGTKMEndpointFailed: true
      });
    }
  } else {
    if (isPurchase) {
      updateStepOrdersInDomainStepPurchase({
        gtkmData,
        dispatch,
        state
      });
    } else {
      updateStepOrdersInDomainStep({
        gtkmData,
        dispatch,
        isGTKMEndpointFailed: true,
        state
      });
    }
  }
};